import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  Grid,
  TextField,
  Typography,
  Snackbar,
  IconButton,
  Tooltip,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CloseIcon from '@mui/icons-material/Close';

const MicrosoftLandingPage = () => {
  const [searchParams] = useSearchParams();
  const [subscriptionId, setSubscriptionId] = useState('');
  const [email, setEmail] = useState('');
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [walletType, setWalletType] = useState('');

  let baseUrl = process.env.REACT_APP_API_BASE_URL || '';
  if (baseUrl && !baseUrl.endsWith('/')) baseUrl += '/';
 
  useEffect(() => {
    const subId = searchParams.get('subscriptionId');
    if (subId) setSubscriptionId(subId);
  }, [searchParams]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Submitting form with:', { subscriptionId, email, walletType });
    if (!walletType) {
      showSnackbar('Please select a wallet type.');
      return;
    }
    try {
      const response = await fetch(`${baseUrl}api/update-subscription-email/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ subscriptionId: subscriptionId, email, walletType }),
      });

      if (response.ok) {
        showSnackbar('Email and wallet type updated successfully!');
      } else {
        showSnackbar('Failed to update email.');
      }
    } catch (error) {
      showSnackbar('Error submitting the form.');
      console.error(error);
    }
  };



  const showSnackbar = (message) => {
    setSnackbarMessage(message);
    setOpenSnackbar(true);
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Box
        sx={{
          boxShadow: 3,
          borderRadius: 2,
          p: 4,
          bgcolor: '#fff',
          border: '2px solid #185b21',
        }}
      >
        <Typography
          variant="h5"
          gutterBottom
          align="center"
          sx={{ color: '#185b21', fontWeight: 700, letterSpacing: 1 }}
        >
          Thank you for your subscription!
        </Typography>
        <Typography
          variant="body1"
          gutterBottom
          align="center"
          sx={{ color: '#185b21', fontWeight: 500 }}
        >
          Please enter your email and let us know which type of wallet you want: <b style={{ color: '#fbb117' }}>Email-based</b> or <b style={{ color: '#fbb117' }}>Tenant-based</b> subscription.
        </Typography>
        <Box mt={5} />
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TextField
                label="Subscription ID"
                fullWidth
                value={subscriptionId}
                disabled
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Your Email"
                fullWidth
                required
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle1" gutterBottom>
                Select Wallet Type
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={6}>
              <Button
                variant={walletType === 'email' ? 'contained' : 'outlined'}
                fullWidth
                onClick={() => setWalletType('email')}
                type="button"
                sx={{
                  backgroundColor: walletType === 'email' ? '#fbb117' : '#fff',
                  color: walletType === 'email' ? '#185b21' : '#185b21',
                  borderColor: '#fbb117',
                  borderWidth: 2,
                  fontWeight: 600,
                  '&:hover': {
                    backgroundColor: '#fbb117',
                    color: '#185b21',
                  },
                }}
              >
                Email-based
              </Button>
                </Grid>
                <Grid item xs={6}>
              <Button
                variant={walletType === 'tenant' ? 'contained' : 'outlined'}
                fullWidth
                onClick={() => setWalletType('tenant')}
                type="button"
                sx={{
                  backgroundColor: walletType === 'tenant' ? '#fbb117' : '#fff',
                  color: walletType === 'tenant' ? '#185b21' : '#185b21',
                  borderColor: '#fbb117',
                  borderWidth: 2,
                  fontWeight: 600,
                  '&:hover': {
                    backgroundColor: '#fbb117',
                    color: '#185b21',
                  },
                }}
              >
                Tenant-based
              </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                fullWidth
                type="submit"
                sx={{
                  backgroundColor: '#185b21',
                  color: '#fff',
                  fontWeight: 700,
                  '&:hover': {
                    backgroundColor: '#fbb117',
                    color: '#185b21',
                  },
                }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        message={snackbarMessage}
        action={
          <IconButton size="small" color="inherit" onClick={handleCloseSnackbar}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      />
    </Container>
  );
};

export default MicrosoftLandingPage;
